<div class="rich-text-editor-container">
  @if (label) {
    <label class="rich-text-editor-label">{{ label }}</label>
  }
  <rich-textarea
    #richText
    [mentionConfig]="config"
    [placeholder]="placeholder"
    [initialContent]="initialContent"
    (contentChange)="onRichTextChange($event)"
    [disabledFormats]="disabledFormats"
    [enableLinkInsert]="enableLinkInsert">
  </rich-textarea>
  @if (invalidMsg) {
    <span class="rich-text-editor-container__invalid-msg">*{{ invalidMsg }}</span>
  }
</div>
